import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit} from '@angular/core';
import {BrandingApiService} from '../../../../../projects/api/src/branding/branding-api.service';
import {ConfigureService} from '../../../../../projects/common/modules/configure/configure.service';
import {CommonModule} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class HeaderLogoComponent implements  OnInit, OnDestroy {

  @Input() prefix: string;
  private translate = inject(TranslateService);
  private cdRef = inject(ChangeDetectorRef);
  private langChangeSub: Subscription;
  showDefaultLogo = false;
  logoImageUrl = null;
  currentLang = this.translate.currentLang;

  constructor(private brandingApi: BrandingApiService, private configService: ConfigureService) {
  }

  ngOnInit() {
    this.setDefaultLogoImage();

    this.langChangeSub = this.translate.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang;
      this.cdRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  setDefaultLogoImage() {

    if (this.configService.options.appConfig.logoUrl) {
      this.logoImageUrl = this.configService.options.appConfig.logoUrl;
    }

    this.brandingApi.isExist('headerLogo').subscribe(data => {
        if (data) {
          this.logoImageUrl = this.brandingApi.makeImageUrl('headerLogo');
          this.showDefaultLogo = false;
          this.cdRef.detectChanges();
        } else {
          this.showDefaultLogo = true;
        }
      }, error => {
        this.showDefaultLogo = true;
        console.log(error);
      }
    );
  }
}
